import { render, staticRenderFns } from "./AutoAddProductsAdded.vue?vue&type=template&id=6bfe6315&scoped=true"
import script from "./AutoAddProductsAdded.vue?vue&type=script&lang=js"
export * from "./AutoAddProductsAdded.vue?vue&type=script&lang=js"
import style0 from "./AutoAddProductsAdded.vue?vue&type=style&index=0&id=6bfe6315&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe6315",
  null
  
)

export default component.exports